export default __webpack_public_path__ + "3600613ed8554a30d6f47bebe0170f22eb2cf3dd01b7024d3ed8937a3be3ecd7.png";